import React from 'react';
import * as lodash from 'lodash';

import styles from './validation.scss';

const PasswordValidation = (props) => {
    const { formApi, confirmPasswordField, themeV3 } = props;
    const {
        values,
        submits,
        errors,
    } = formApi;

    const passwordIndicator = (valid, name) => {
        return themeV3 ? (
            <div className={styles.tag}>
                <span>
                    <img
                        src={`/img/v2/${
                            valid ? 'blue-check-icon.svg' : 'red-close-icon.svg'
                        }`}
                    />
                </span>{' '}
                {name}
            </div>
        ) : (
            <span
                className={valid ? styles.indicatorValid : styles.indicatorInvalid}
            >
                <span />
                {name}
            </span>
        );
    };

    return (
        <div className={`${styles.indicators} ${themeV3 ? styles.themeV3 : ''} ${submits > 0 && !lodash.isEmpty(errors) ? styles.error : ''} d-flex justify-content-start`}>
            {values.password && (
                <>
                    {passwordIndicator(values.password.length > 7, themeV3 ? '8 char.' : '8 Characters')}
                    {passwordIndicator(/.*[A-Z].*/.test(values.password), themeV3 ? '1 uppercase' : 'Uppercase')}
                    {themeV3 && passwordIndicator(/.*[a-z].*/.test(values.password), '1 lowercase')}
                    {passwordIndicator(/.*[0-9].*/.test(values.password), themeV3 ? '1 number' : 'Numbers')}
                </>
            )}
            {!!confirmPasswordField && (
                <React.Fragment>
                    {passwordIndicator((!!values[confirmPasswordField] && values.password === values[confirmPasswordField]), 'Password Match')}
                </React.Fragment>
            )}
        </div>
    );
};

export default PasswordValidation;
